import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import {
  appDialogBackdropSx,
  appDialogPaperSx,
  AppDialogBody,
  AppDialogCloseButton,
  AppDialogCloseIcon,
  AppDialogFooter,
  AppDialogHeader,
  AppDialogHeading,
  AppDialogSubtitle,
} from "./AppDialog.styles";

const AppDialog = ({
  open,
  onClose,
  "aria-labelledby": ariaLabelledBy,
  heading,
  subtitle,
  footer,
  children,
  ...rest
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby={ariaLabelledBy}
    slotProps={{
      paper: { sx: appDialogPaperSx },
      backdrop: { sx: appDialogBackdropSx },
    }}
    {...rest}
  >
    <AppDialogHeader>
      <AppDialogHeading
        id={ariaLabelledBy}
        variant="h2"
        component="h2"
      >
        {heading}
      </AppDialogHeading>
      {onClose ? (
        <AppDialogCloseButton
          aria-label="Close"
          onClick={onClose}
          size="small"
        >
          <AppDialogCloseIcon />
        </AppDialogCloseButton>
      ) : null}
    </AppDialogHeader>
    {subtitle != null ? (
      <AppDialogSubtitle component="p">{subtitle}</AppDialogSubtitle>
    ) : null}
    {children != null ? (
      <AppDialogBody component="div" $hasSubtitle={subtitle != null}>
        {children}
      </AppDialogBody>
    ) : null}
    {footer != null ? <AppDialogFooter>{footer}</AppDialogFooter> : null}
  </Dialog>
);

AppDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  "aria-labelledby": PropTypes.string,
  heading: PropTypes.node,
  subtitle: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
};

export default AppDialog;
